var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9999 19.2C4.01168 19.2 2.3999 17.5882 2.3999 15.6V8.3999C2.3999 6.41168 4.01168 4.7999 5.9999 4.7999H11.3999M16.1999 4.7999H17.9999C19.9881 4.7999 21.5999 6.41168 21.5999 8.3999V15.6C21.5999 17.5882 19.9881 19.2 17.9999 19.2H10.1999M12.5999 21.5999L10.1999 19.2L12.5999 16.7999M10.1999 7.1999L12.5999 4.7999L10.1999 2.3999",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.a50ab047d1d5b1f5ecdf93f657af0da8.svg";
export { ForwardRef as ReactComponent };